import { render } from "./projectset.vue?vue&type=template&id=6b2ad1c4"
import script from "./projectset.vue?vue&type=script&lang=ts"
export * from "./projectset.vue?vue&type=script&lang=ts"
script.render = render

export default script